import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Incapacity {
  id: number;
  title: string;
  description: string;
  approved: boolean;
  isRejected: boolean;
  isRequest: boolean;
  startDate: number;
  endDate: number;
  daysOff: number;
  createdAt: string;
  partner?: {
    person?: {
      firstName?: string;
      lastName?: string;
      secondLastName?: string;
    };
  };
  reviewerBy?: {
    name?: string;
    lastName?: string;
  };
}

interface IncapacitiesState {
  incapacities: Incapacity[];
  total: number;
  page: number;
  limit: number;
  query: string;
  sortBy: string;
  defaultSort: string;
}

const initialState: IncapacitiesState = {
  incapacities: [],
  total: 0,
  page: 0,
  limit: 10,
  query: '',
  sortBy: 'createdAt',
  defaultSort: 'desc',
};

const incapacitiesSlice = createSlice({
  name: 'incapacities',
  initialState,
  reducers: {
    setIncapacities: (state, action: PayloadAction<Incapacity[]>) => {
      state.incapacities = action.payload;
    },
    setTotal: (state, action: PayloadAction<number>) => {
      state.total = action.payload;
    },
    setPage: (state, action: PayloadAction<number>) => {
      state.page = action.payload;
    },
    setLimit: (state, action: PayloadAction<number>) => {
      state.limit = action.payload;
    },
    setQuery: (state, action: PayloadAction<string>) => {
      state.query = action.payload;
    },
    setSortBy: (state, action: PayloadAction<string>) => {
      state.sortBy = action.payload;
    },
    setDefaultSort: (state, action: PayloadAction<string>) => {
      state.defaultSort = action.payload;
    },
    resetIncapacities: (state) => {
      state.incapacities = [];
      state.total = 0;
      state.page = 0;
      state.query = '';
    },
  },
});

export const {
  setIncapacities,
  setTotal,
  setPage,
  setLimit,
  setQuery,
  setSortBy,
  setDefaultSort,
  resetIncapacities,
} = incapacitiesSlice.actions;

export default incapacitiesSlice.reducer;
